import React,{useState, useEffect} from 'react';
import { Box } from "@mui/material";
import PaginationTable from '../../../../../component/PaginationTable';
import { PolicyTableHeadings} from '../../../../../styles/PolicyTableHeadings';
import { PolicyTableCell} from '../../../../../styles/PolicyTableCell';
import { StatusChip } from '../../../../../component/listing';
import { getSelfAttendanceRequests } from '../../../../../services/attendanceRequest';
import { useNotify } from '../../../../../component/NotificationProvider';

const TYPE_LABEL = {
  REGULARIZATION: "Regularization",
  SHIFT_CHANGE: "Shift Change",
};

const RequestUpdatesTable = () => {
    const notify = useNotify();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        (async () => {
          setLoading(true);
          try {
            const res = await getSelfAttendanceRequests();
            if (res?.success === false) {
              throw new Error(res?.message || "Failed to load requests");
            }
            if (active) setData(Array.isArray(res?.data) ? res.data : []);
          } catch (error) {
            if (active) notify.error(error?.message || "Failed to load requests");
          } finally {
            if (active) setLoading(false);
          }
        })();
        return () => { active = false; };
      }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const headings = [
      { label: "Request ID", style: {...PolicyTableHeadings, width:"14.93rem", borderTopLeftRadius: "12px", borderBottomLeftRadius: "12px" } },
      { label: "Request Type", style: {...PolicyTableHeadings,  width:"12.25rem"} },
      { label: "Date", style: {...PolicyTableHeadings, width:"12.56rem"} },
      { label: "Approval Status", style: { ...PolicyTableHeadings,width:"20.06rem", borderTopRightRadius: "12px", borderBottomRightRadius: "12px" } }
    ];

  return (
    <Box>
        <PaginationTable
          rows={data}
          headings={headings}
          loading={loading}
          noRecordMessage={"No Record Found"}
          renderCell={(row) => {
            const status = (row?.status || "Pending").toLowerCase();
            const date = row?.dayString || (row?.createdAt ? new Date(row.createdAt).toLocaleDateString('en-GB') : "--");
            return (
            <>
              <PolicyTableCell>{row?._id?.slice(-6)?.toUpperCase()}</PolicyTableCell>
              <PolicyTableCell>{TYPE_LABEL[row?.type] || row?.type}</PolicyTableCell>
              <PolicyTableCell>{date}</PolicyTableCell>
              <PolicyTableCell>
               <Box sx={{width:"100%", display:"flex", justifyContent:"center"}}>
                 <StatusChip
                   label={status.charAt(0).toUpperCase() + status.slice(1)}
                   tone={status === "pending" ? "muted" : status === "rejected" ? "danger" : "success"}
                 />
               </Box>
              </PolicyTableCell>
            </>
          )}}
        />
    </Box>
  )
}

export default RequestUpdatesTable
